<template>
	<svg
		class="shared-svg-icon"
		:class="`icon-${iconName}`"
		:aria-hidden="!title ? 'true' : undefined"
		:aria-labelledby="title ? titleId : undefined"
	>
		<title v-if="title" :id="titleId">{{ title }}</title>
		<use :xlink:href="`#icon-${iconName}`" :href="`#${iconPrefix ? 'icon-' : ''}${iconName}`" />
	</svg>
</template>

<script setup lang="ts">
import type { SpriteSymbol } from "../../types/GeneratedSpriteType";
withDefaults(
	defineProps<{
		iconName: SpriteSymbol;
		iconPrefix?: boolean;
		title?: string;
	}>(),
	{ iconPrefix: true }
);

const titleId = (Math.random() + 1).toString(36).substring(2);
</script>

<style>
.shared-svg-icon {
	display: inline-block;
	stroke-width: 0;
	stroke: currentColor;
	fill: currentColor;
}
</style>
